import EnumerationWidget from './EnumerationWidget';

export default EnumerationWidget;
